import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { apiApplyCancelPromo, apiGetCancelABTest, apiGetCancelData, apiUnsubscribe } from "Root/api/apiProfile";
import { setGlobalLoading, setProfileStoreAction, setSettingsStoreAction, setHomeStoreAction, setSubscriptionStoreAction, } from "Root/profile/redux/actionCreators/makeActionCreator";
import { fetchCommunicationPrefsThunk, fetchUserAccountThunk, } from "Root/profile/redux/thunkCreators/accountSettings/accountSettingsThunk";
import { fetchProfileDataThunk } from "Root/profile/redux/thunkCreators/myProfile/profileThunk";
import { LoadNextOrderDatesThunk } from "Root/profile/redux/thunkCreators/orders/nextOrderDates";
import LoadProfileInfoThunk from "Root/profile/redux/thunkCreators/user/user";
import toastService from "Root/profile/toastService";
import { getInfoForReason, cancelSteps, workingOutLessSteps, buildPayload } from "./data";
import sendPostHogDataHelper from "Root/hooks/sendPostHogDataHelper";
const useCancelSubscriptionV2 = () => {
    const [cancelData, setCancelData] = useState({
        already_used_cancel_promo: false,
        cancelling_second_time: false,
        first_order_arrives: false,
        already_used_cancel_rewards: false,
        already_filed_complaint: false,
    });
    const [reason, setReason] = useState("");
    const [hiddenReason, setHiddenReason] = useState("");
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    const [textValue, setTextValue] = useState("");
    const [radioValue, setRadioValue] = useState("");
    const [workingLessReason, setWorkingLessReason] = useState("");
    const [discountOffer, setDiscountOffer] = useState("");
    const [discountOfferBtn, setDiscountOfferBtn] = useState("");
    const [workingLessIndex, setWorkingLessIndex] = useState(0);
    const profileData = useSelector((state) => state.myProfile.originalAnswers);
    const points = useSelector((state) => state.accountSettings.userAccount.availablePointBalance);
    const amount = `$${Math.floor(points / 20 / 5) * 5}`;
    const history = useHistory();
    const backHome = (deflect = true, properties = {}) => {
        history.push("/app/subscription/");
        if (deflect) {
            sendPostHogDataHelper("cancel deflect", properties);
        }
    };
    const reduxStoreIsEmpty = useSelector((state) => state.checkStore.profile);
    const accountStoreIsEmpty = useSelector((store) => store.checkStore.settings);
    const scrollUp = () => {
        window.scrollTo(0, 0);
    };
    const dispatch = useDispatch();
    const goBack = () => {
        if (workingLessReason) {
            if (workingLessIndex === 0) {
                setWorkingLessReason("");
            }
            else {
                setWorkingLessIndex(workingLessIndex - 1);
            }
            return;
        }
        if (!reason) {
            backHome(true, { how: "back_arrow" });
            return;
        }
        if (reason) {
            if (currentStepIndex === 0) {
                setReason("");
                setHiddenReason("");
                if (workingLessReason) {
                    if (workingLessIndex === 0) {
                        setCurrentStepIndex(0);
                        setWorkingLessReason("");
                    }
                    else {
                        setWorkingLessIndex(workingLessIndex - 1);
                    }
                }
                else if (!workingLessReason && currentStepIndex === 0) {
                    if (reason) {
                        setReason("");
                        setHiddenReason("");
                    }
                }
            }
            else {
                setCurrentStepIndex(currentStepIndex - 1);
            }
        }
        scrollUp();
    };
    const fetchCancelData = async () => {
        setLoading(true);
        const data = await apiGetCancelData();
        setCancelData(data);
        setLoading(false);
    };
    const selectReason = (value) => {
        setRadioValue("");
        setTextValue("");
        setReason(value);
        if (value !== "lessExercise") {
            if (cancelData.already_filed_complaint && ["taste", "medical", "other"].includes(value)) {
                setHiddenReason("already_filed_complaint");
            }
            else if ((cancelData.already_used_cancel_promo || cancelData.already_used_cancel_rewards) &&
                value === "shippingIssue") {
                setHiddenReason("already_cancelled_shipping_issue");
            }
            else if ((cancelData.already_used_cancel_promo || cancelData.already_used_cancel_rewards) &&
                value !== "shippingIssue") {
                setHiddenReason("already_cancelled");
            }
            else if (cancelData.cancelling_second_time) {
                setHiddenReason("cancel_2nd");
            }
            else if (cancelData.first_order_arrives) {
                setHiddenReason("before_arrive");
            }
        }
        scrollUp();
        sendPostHogDataHelper("cancel reason_select", { reason: value });
    };
    const onChangeTextValue = (value) => {
        setTextValue(value);
    };
    const clearState = async () => {
        dispatch(setProfileStoreAction(true));
        dispatch(setSettingsStoreAction(true));
        dispatch(setHomeStoreAction(true));
        dispatch(setSubscriptionStoreAction(true));
        await dispatch(LoadNextOrderDatesThunk());
        await dispatch(LoadProfileInfoThunk());
    };
    const stepIsFeedback = (hiddenReason || reason) &&
        cancelSteps[hiddenReason || reason] &&
        cancelSteps[hiddenReason || reason][currentStepIndex] === "feedback";
    const workingLessIsFeedback = workingLessReason && workingOutLessSteps[workingLessReason][workingLessIndex] === "feedback";
    const reasonPayload = (hiddenReason || reason) &&
        getInfoForReason(hiddenReason || reason, cancelSteps[hiddenReason || reason][currentStepIndex], profileData.reasons, workingLessReason, workingLessReason ? workingOutLessSteps[workingLessReason][workingLessIndex] : "", discountOffer, discountOfferBtn);
    const clearStateAndGoHome = () => {
        clearState();
        backHome(true);
        scrollUp();
        dispatch(setGlobalLoading(false));
    };
    const onMainBtnClick = async () => {
        const payload = buildPayload(reason, cancelSteps[hiddenReason || reason][currentStepIndex], workingLessReason, workingLessReason && workingOutLessSteps[workingLessReason][workingLessIndex]);
        if (reasonPayload && !reasonPayload.secondaryBtnText) {
            if (textValue && !cancelData.already_filed_complaint) {
                payload.feedback = textValue;
                await apiApplyCancelPromo(payload);
            }
            if (radioValue &&
                !cancelData.already_filed_complaint &&
                !["submit_feedback_RD", "submit_feedback_cx", "submit_feedback_shipping"].includes(payload.step)) {
                payload.radio_value = radioValue;
                await apiApplyCancelPromo(payload);
            }
            setCurrentStepIndex(currentStepIndex + 1);
        }
        else {
            dispatch(setGlobalLoading(true));
            if (radioValue) {
                payload.radio_value = radioValue;
            }
            if (textValue) {
                payload.feedback = textValue;
            }
            if (cancelData.already_filed_complaint &&
                ["submit_feedback_RD", "submit_feedback_cx", "submit_feedback_shipping", "redeem_coupon"].includes(payload.step)) {
                clearStateAndGoHome();
                return;
            }
            if ((cancelData.already_used_cancel_promo || cancelData.already_used_cancel_rewards) &&
                payload.step === "add_points") {
                clearStateAndGoHome();
                return;
            }
            try {
                const data = await apiApplyCancelPromo(payload);
                if (data.bannerText) {
                    toastService.successMessage(data.bannerText);
                }
                clearState();
                backHome(true);
            }
            catch (e) {
                toastService.errorMessage("You've already redeemed this offer");
                clearState();
                backHome(true);
            }
            finally {
                dispatch(setGlobalLoading(false));
                scrollUp();
            }
        }
    };
    const onSecBtnClick = async () => {
        if (currentStepIndex === cancelSteps[hiddenReason || reason].length - 1) {
            dispatch(setGlobalLoading(true));
            await apiUnsubscribe({ cancel_reasons: reason });
            sendPostHogDataHelper("cancel complete", { reason: reason });
            if (workingLessReason) {
                setWorkingLessReason("");
                setWorkingLessIndex(0);
            }
            setReason("");
            setHiddenReason("");
            setCurrentStepIndex(0);
            clearState();
            backHome(false);
            dispatch(setGlobalLoading(false));
        }
        else if (workingLessReason) {
            if (workingLessIndex === workingOutLessSteps[workingLessReason].length - 1) {
                dispatch(setGlobalLoading(true));
                await apiUnsubscribe({ cancel_reasons: reason });
                toastService.successMessage("Your subscription has been cancelled");
                sendPostHogDataHelper("cancel complete", { reason: reason });
                setWorkingLessReason("");
                setWorkingLessIndex(0);
                setReason("");
                setHiddenReason("");
                setCurrentStepIndex(0);
                clearState();
                backHome(false);
                dispatch(setGlobalLoading(false));
            }
            else {
                setWorkingLessIndex(workingLessIndex + 1);
            }
        }
        else {
            setCurrentStepIndex(currentStepIndex + 1);
        }
        scrollUp();
    };
    const onClickWorkingLessButton = (workingReason) => {
        setWorkingLessReason(workingReason);
        if (cancelData.already_filed_complaint) {
            setHiddenReason("already_filed_complaint");
        }
        else if (cancelData.already_used_cancel_promo || cancelData.already_used_cancel_rewards) {
            setHiddenReason("already_cancelled");
        }
        else if (cancelData.cancelling_second_time) {
            setHiddenReason("cancel_2nd");
        }
        else if (cancelData.first_order_arrives) {
            setHiddenReason("before_arrive");
        }
    };
    const onChangeRadio = (value) => {
        setRadioValue(value);
    };
    const [showHeader, setShowHeader] = useState(false);
    useEffect(() => {
        if (reduxStoreIsEmpty) {
            dispatch(fetchProfileDataThunk());
            dispatch(setProfileStoreAction(false));
        }
        if (accountStoreIsEmpty) {
            dispatch(fetchCommunicationPrefsThunk());
            dispatch(fetchUserAccountThunk());
            dispatch(setSettingsStoreAction(false));
        }
        setShowHeader(true);
        fetchCancelData();
        sendPostHogDataHelper("cancel start", {});
    }, []);
    const fetchOffer = async () => {
        // setLoading(true);
        const abData = await apiGetCancelABTest(reason);
        if (abData === "1") {
            setDiscountOffer("Take 30% off your next order");
            setDiscountOfferBtn("Claim 30% off");
        }
        else {
            setDiscountOffer("Take 20% off your next 2 orders");
            setDiscountOfferBtn("Claim 20% off 2 orders");
        }
        // setLoading(false);
    };
    useEffect(() => {
        if (hiddenReason || reason) {
            const step = cancelSteps[hiddenReason || reason][currentStepIndex];
            sendPostHogDataHelper("cancel next_step", { step: step });
            if (step === "price_off" || step === "stay") {
                fetchOffer();
            }
        }
    }, [currentStepIndex]);
    return {
        goBack,
        backHome,
        reason,
        selectReason,
        currentStepIndex,
        setCurrentStepIndex,
        radioValue,
        setRadioValue,
        textValue,
        onChangeTextValue,
        onMainBtnClick,
        onSecBtnClick,
        showHeader,
        reasonPayload,
        stepIsFeedback,
        onChangeRadio,
        onClickWorkingLessButton,
        workingLessIsFeedback,
        points,
        amount,
        goals: profileData.reasons,
        loading,
    };
};
export default useCancelSubscriptionV2;
